import styled from 'styled-components';

export const ProgramSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%;
  background-color: #fff;

  iframe {
    border: none;
  }

  .no-data-alert {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: white;
  }

  .white-bg {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;
    background-color: #fff;
  }
`;
